import { render, staticRenderFns } from "./LicenseHistoryModel.vue?vue&type=template&id=a8c00cba&"
import script from "./LicenseHistoryModel.vue?vue&type=script&lang=js&"
export * from "./LicenseHistoryModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports